/* <![CDATA[ */

/*global
 current_general_acknowledgement_id, frontend_custom_data
 */

/*property
 adaptiveHeight, add, addClass, addEventListener, arrows, attr, before, body,
 breakpoint, change, chkFld, classList, closest, cookie, currentTime,
 current_general_acknowledgement_id, data, each, fade, find, first, focus,
 get, hasClass, indexOf, infinite, jQuery, length, minimumResultsForSearch,
 not, on, parents, pause, play, preventDefault, ready, remove, removeAttr,
 removeClass, removeEventListener, resize, responsive, selectWoo,
 setUTCHours, settings, slick, slidesToScroll, slidesToShow, src, startsWith,
 submit, swipe, text, toGMTString, toLocaleLowerCase, toggleClass, trim, val,
 width
 */

// import 'whatwg-fetch'; // polyfill fetch (<2017)
// import 'promise-polyfill/src/polyfill'; // polyfill promises for fetch (IE11)
// import 'babel-polyfill'; // polyfill promises and ES2015 methods (mainly IE11) https://github.com/zloirock/core-js
// import Vue from 'vue';
// import 'magnific-popup';
// import './modules/googleanalytics';
// import { analytics } from './modules/analytics'; //GA tracking for custom events and pagevies
// import { render_map } from './modules/map';

import {slick} from 'slick-carousel/slick/slick';
import {cookies} from './modules/cookies';
import MicroModal from 'micromodal';
const $ = window.jQuery;
window.addEventListener('touchstart', function onFirstTouch() {
  document.body.classList.add('touch-device');
  window.removeEventListener('touchstart', onFirstTouch, false);
});

$(document).ready(function () {

  MicroModal.init();

  $('.bundle-items-table').on('click', '.bundle-info-link', function (event) {
    event.preventDefault();

    const productId = $(this).data('id');

    // Alusta sisältö valmiiksi – mutta älä vielä näytä modalia
    $('#bundle-modal-content').html('<p>' + frontend_custom_data.download_text + '</p>');

    $.ajax({
      url: frontend_custom_data.ajax_url,
      type: 'POST',
      data: {
        action: 'opike_get_bundle_item_info',
        product_id: productId
      },
      success: function (response) {
        $('#bundle-modal-content').html(response);
        MicroModal.show('bundle-modal'); // modaali avataan vasta kun sisältö valmis
      },
      error: function () {
        $('#bundle-modal-content').html('<p>' + frontend_custom_data.error_text + '</p>');
        MicroModal.show('bundle-modal');
      }
    });
  });

  $('.search-field').on('blur', function () {
    $(this).val($.trim($(this).val()));
    $.chkFld($(this).attr('id'));
  });

  $('#toggle-mobile-menu').on('click', function () {
    $(this).toggleClass('is-active');
    $('body').toggleClass('menu-open');
  });

  $('#toggle-sidebar').on('click', function () {
    $(this).toggleClass('is-active');
    $('#main-sidebar, .woocommerce-MyAccount-navigation').toggleClass('open');
  });

  //interactive product carousel play video
  $('.carousel-view .carousel-video-wrap button.play-video').on('click', function (event) {

    var videoId = $(this).data('videoid');
    event.preventDefault();
    $(this).closest('.carousel-video-wrap').addClass('play-slide-video');
    $('#video-' + videoId)[0].play();
  });

  //if theres featured video for product, replace empty img tag sources in slider
  $('.woocommerce-product-gallery .flex-control-nav img').on('click', function () {
    if ($(this).attr('src').startsWith('data:image')) {
      $(this).closest('.woocommerce-product-gallery').addClass('video-visible');
    } else {
      $(this).closest('.woocommerce-product-gallery').removeClass('video-visible');
    }
  });

  setTimeout(function () {
    $('.woocommerce-product-gallery .flex-control-nav img').each(function () {
      if ($(this)[0].src.indexOf('data:image') > -1 || $(this)[0].src.indexOf('youtu') > -1 || $(this)[0].src.indexOf('default-video-thumb') > -1) {
        $(this).addClass('video-thumb');
        $(this).closest('li').addClass('video-thumb-item');
        $(this).closest('.woocommerce-product-gallery').addClass('video-visible');
      }
    });
  }, 10);

  $(window).resize(function () {
    var $windowWidth = $(window).width();
    if ($windowWidth > 768) {
      init_selected_posts_carousel();
    }
  });
  init_selected_posts_carousel();
  init_top_carousel();
  init_gallery_carousels();
  init_file_searches();
  init_register_form();
  init_checkout_modifications();
  init_storefront_modification();
  $('.woocommerce-message').removeAttr('tabindex');
});

function init_checkout_modifications() {
  $('form[name=checkout] .form-row label').each(function () {
    if ($(this).attr('for') === 'billing_email') {
      $(this).find('.required').before('<span class="additional-invalid-indicator">Tämä kenttä on virheellisesti täytetty.</span>');
    }
    $(this).find('.required').before('<span class="additional-required-indicator">Tämä kenttä on pakollinen.</span>');
    $(this).closest('.form-row').find('input, select, checkbox, radio, textarea').attr('required', 'required');
  });
}

function init_storefront_modification() {
  if ($('.woocommerce-message').length) {
    $('.woocommerce-message:first').attr('tabindex', 0);
    $('.woocommerce-message:first').get(0).focus();
  }
}

function init_selected_posts_carousel() {
  $('.block-selectedposts .carousel').each(function () {
    if ($(this).hasClass('slick-initialized')) {
      return;
    }

    $(this).slick({
      infinite: true,
      slidesToShow: $(this).data('slides-to-show'),
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: "unslick"
        }
      ]
    });
  });
}

// deprecated 9.3.
function init_top_carousel() {

  var navigation = $('#top-carousel-navigation');
  var slider = $(navigation.data("slick-navigation"));
  var carousel = $('.block-top-carousel .carousel-views');
  if (carousel.hasClass('slick-initialized')) {
    return;
  }

  carousel.slick({
    infinite: true,
    fade: true,
    arrows: false,
    swipe: false,
    adaptiveHeight: true
  });
  navigation.find("li:first").addClass("active");
  navigation.find("li").each(function (index) {
    var link = $(this).find("a");
    link.data("slide", index);
    link.on("click", function (event) {
      event.preventDefault();
      slider.find('video')[0].pause();
      navigation.find("li").removeClass("active");
      $(this).parents("li").addClass("active");
      slider.slick("slickGoTo", $(this).data("slide"));
    });
  });
}

// deprecated

function init_gallery_carousels() {

  $('.block-gallery-carousel .carousel-views').each(function (ignore) {

    var slick_elem = null;
    var navigation = null;
    var slider = null;
    if ($(this).hasClass('slick-initialized')) {
      return;
    }

    slick_elem = $(this).slick({
      infinite: true,
      fade: true,
      arrows: false,
      swipe: false,
      adaptiveHeight: true
    });
    navigation = $(this).closest('.block-gallery-carousel').find('.carousel-navigation');
    slider = $(navigation.data("slick-navigation"));
    navigation.find("li:first").addClass("active");
    navigation.find("li").each(function (index) {
      var link = $(this).find("a");
      link.data("slide", index);
      link.on("click", function (event) {
        event.preventDefault();
        $(this).closest('.block-gallery-carousel').find('.carousel-view video').each(function (ignore) {
          this.pause();
          this.currentTime = 0;
        });
        slider.find('.carousel-video-wrap').removeClass('play-slide-video');
        navigation.find("li").removeClass("active");
        $(this).parents("li").addClass("active");
        slider.slick("slickGoTo", $(this).data("slide"));
      });
    });
  });
}

function init_file_searches() {
  if ($('.file-list-filter').length > 0) {
    $('.file-list-filter').each(function (ignore) {
      $(this).submit(function (event) {
        event.preventDefault();
        filter_file_list($(this));
        return false;
      });
    });
    $('.file-filter-text').on('keyup', function (ignore) {
      filter_file_list($(this).closest('.file-list-filter'));
    });
    $('.clear-filters').each(function (ignore) {

      var $search_form = null;
      $(this).on('click', function (ignore) {
        $search_form = $(this).closest('.file-list-filter');
        $search_form.find('.file-filter-text:first').val('');
        $search_form.submit();
      });
    });
  }
}

function filter_file_list($form) {

  var search_text = $form.find('.file-filter-text:first').val();
  var $error_span = $form.find('.error-message');
  var $container = $form.closest('.block-files-in-folder, .block-file-list').first();
  if (search_text.length > 0 && search_text.length < 3) {
    $container.find('.file-name').removeClass('hide');
    $form.addClass("error");
    $form.addClass("filtered-results");
  } else if (search_text.length === 0) {
    $container.find('.file').removeClass('hide');
    $form.removeClass('error');
    $form.removeClass('filtered-results');
  } else {
    $container.find('.file-group').removeClass('hide').each(function (ignore) {

      var group_has_results = false;
      if ($(this).find('.folder-name').text().toLocaleLowerCase().indexOf(search_text.toLocaleLowerCase()) > -1) {
        group_has_results = true;
      } else {
        $(this).find('.file').removeClass('hide').each(function (ignore) {
          if ($(this).find('.search-terms').text().toLocaleLowerCase().indexOf(search_text.toLocaleLowerCase()) < 0) {
            $(this).addClass('hide');
          } else {
            group_has_results = true;
          }
        });
      }

      if (!group_has_results) {
        $(this).addClass('hide');
      }
    });
    $form.removeClass('error');
    $form.addClass('filtered-results');
  }

// check if any files in group visible
  $container.find('.file-group').each(function (ignore) {
    if ($(this).find('.file').not('.hide').length > 0) {
      $(this).removeClass('hide');
    } else {
      $(this).addClass('hide');
    }
  });
}

function init_register_form() {

  $('#show-registration, #show-login').on('click', function (event) {
    if (event) {
      event.preventDefault();
    }

    $('.woocommerce-notices-wrapper').remove();
    $('#customer_type').closest('.woocommerce-form-register').find('input[type=text], input[type=email]').val('');
    $('#customer_type').val('default').change();
    $('#reg_shipping_country, #reg_billing_country').val('FI').change();
    $('#login-col, #register-col').toggleClass('hide');
  });
  $('.woocommerce-notices-wrapper .showlogin').on('click', function () {
    $('.woocommerce-notices-wrapper').remove();
    $('#customer_type').closest('.woocommerce-form-register').find('input[type=text], input[type=email]').val('');
    $('#customer_type').val('default').change();
    $('#reg_shipping_country, #reg_billing_country').val('FI').change();
    $('#login-col, #register-col').toggleClass('hide');
  });
  if ($('#customer_type').length > 0) {
    $('#customer_type').selectWoo({
      width: '100%',
      minimumResultsForSearch: Infinity
    });
    $('#customer_type').on('change', function () {
      $('.woocommerce-notices-wrapper').remove();
      $(this).closest('.woocommerce-form-register').find('input[type=text], input[type=email]').val(null);
      $('#reg_shipping_country, #reg_billing_country').val('FI').change();
      switch ($(this).val()) {
        case 'organization':
          $(this).closest('.woocommerce-form-register').removeClass('private').addClass('organization');
          break;
        case 'private':
          $(this).closest('.woocommerce-form-register').removeClass('organization').addClass('private');
          break;
      }
    });
    switch ($('#customer_type').val()) {
      case 'organization':
        $('#customer_type').closest('.woocommerce-form-register').removeClass('private').addClass('organization');
        break;
      case 'private':
        $('#customer_type').closest('.woocommerce-form-register').removeClass('organization').addClass('private');
        break;
    }
  }

  if ($('#reg_billing_country').length > 0) {
    $('#reg_billing_country').selectWoo({
      width: '100%'
    });
  }

  if ($('#reg_shipping_country').length > 0) {
    $('#reg_shipping_country').selectWoo({
      width: '100%'
    });
  }

}

// general-acknowledgement box on front page
$('.general-acknowledgement .btn-close').on('click', function (event) {

  var date = new Date();
  var dateString = null;
  var cookieString = null;
  /* event.preventDefault(); */
  $(this).closest('.general-acknowledgement').addClass('hide');
  date.setUTCHours(23, 59, 59, 999);
  dateString = date.toGMTString();
  /* cookieString = current_general_acknowledgement_id + '_shown=1; ' + dateString + '; path=/'; */
  cookieString = frontend_custom_data.current_general_acknowledgement_id + '_shown=1; expires=' + dateString + '; SameSite=None; Secure';
  document.cookie = cookieString;
});
/* ]]> */